module.exports = __webpack_public_path__ + "media/images/icons/twitter-6dd3aee1b89d5f462b4e5bb56e6b8c66.svg";